import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { fetchCollection, updateCollectionCancel, resetCollectionImage } from '../actions';
import collectionDiff, { collectionUppyId } from '../helper';

const CancelCollectionAction = ({
  refresh,
  collection,
  category,
  code,
  isDirty,
  cancelUpdate,
  resetImage,
}) => {
  const intl = useIntl();
  const handleOnClick = () => {
    const updates = collectionDiff(collection);
    const cancel = !isDirty
    || !updates
    || window.confirm(intl.formatMessage({ id: 'collection.edit.cancel.warning' }));

    if (cancel) {
      if (updates) {
        refresh(category, code);
      }
      const uppyId = collectionUppyId(collection);
      resetImage(category, code, uppyId);
      cancelUpdate(category, code);
    }
  };

  return (
    <RibbonMenu
      icon="cancel"
      name="cancel"
      message="actions.cancel"
      onClick={handleOnClick}
      className="aridhia-cancel-collection-action"
    />
  );
};

const mapStateToProps = ({
  collections: { collections },
}, { category, code }) => {
  const collection = findResult(collections, category, code);
  return {
    collection,
    isDirty: collection ? collection.isDirty : false,
  };
};

const mapDispatchToProps = {
  refresh: fetchCollection,
  cancelUpdate: updateCollectionCancel,
  resetImage: resetCollectionImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelCollectionAction);
